var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import i18next from 'i18next';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserSessionAPI } from '../app/selectors';
import { Autocomplete, ErrorMessageBox, FormField } from '../common';
import { languageOptions, validateForm } from './constants';
import { useChangeUserLanguage } from './selectors';
export var SettingLanguage = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var t = useTranslation('translation').t;
    var userData = useUserSessionAPI()[0].data;
    var _b = useChangeUserLanguage(), languageData = _b[0], changeLanguage = _b[1], clearChangeLanguage = _b[2];
    var defaultValues = useMemo(function () { return ({
        language: (userData === null || userData === void 0 ? void 0 : userData.language) || languageOptions[0].id,
    }); }, [userData === null || userData === void 0 ? void 0 : userData.language]);
    var _c = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(validateForm),
    }), control = _c.control, handleSubmit = _c.handleSubmit, reset = _c.reset, getValues = _c.getValues;
    useEffect(function () {
        if (open) {
            clearChangeLanguage();
            reset(defaultValues);
        }
    }, [clearChangeLanguage, open, reset, defaultValues]);
    useEffect(function () {
        if (languageData.data) {
            i18next.services.languageDetector.cacheUserLanguage(getValues('language'));
            window.location.reload();
        }
    }, [languageData.data, getValues]);
    var handleFormSubmit = handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            changeLanguage(values);
            return [2 /*return*/];
        });
    }); });
    return (_jsx(Dialog, __assign({ open: open, onClose: onClose }, { children: _jsxs(Box, __assign({ component: "form", onSubmit: handleFormSubmit }, { children: [_jsx(DialogTitle, __assign({ variant: "h2" }, { children: t('layout.settingLanguage') })), _jsxs(DialogContent, { children: [_jsx(ErrorMessageBox, { errors: [languageData.error] }), _jsx(FormField, __assign({ required: true, name: "language", label: t('layout.pleaseSelect'), control: control }, { children: _jsx(Autocomplete, { options: languageOptions, getOptionLabel: function (option) { return t("layout.languageOption.".concat(option.name)); } }) }))] }), _jsxs(DialogActions, __assign({ sx: { justifyContent: 'space-between' } }, { children: [_jsx(Button, __assign({ variant: "outlined", onClick: onClose }, { children: t('action.cancel') })), _jsx(Button, __assign({ variant: "contained", type: "submit" }, { children: t('action.ok') }))] }))] })) })));
};
